// src/ClientDashboard.jsx
import React from 'react';
import { useAuth } from '../lib/AuthContext';
import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  StarIcon,
  SearchIcon,
  HomeIcon,
  ClipboardListIcon,
  UserIcon,
  BookOpenIcon,
  SparklesIcon,
  MessageSquareIcon,
} from 'lucide-react';
import { Button } from '../components/ui/button';

const SidebarItem = ({ icon: Icon, label, to }) => {
  const location = useLocation();
  const isActive = location.pathname === to || (to === "/client" && location.pathname === "/client");

  return (
    <Link
      to={to}
      className={`flex items-center gap-3 p-2 rounded-md text-sm font-medium ${
        isActive ? 'bg-white text-indigo-600 shadow-sm' : 'text-gray-700 hover:bg-white'
      }`}
    >
      <Icon size={16} />
      {label}
    </Link>
  );
};

const ClientDashboard = () => {
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row">
      {/* Sidebar */}
      <aside className="w-full md:w-64 bg-[#fdf3e8] border-r p-4 space-y-6 text-sm sticky top-0 h-screen">
        <h2 className="text-lg font-semibold text-gray-800 mb-2">🔅 My Space</h2>
        <SidebarItem to="/client" label="Home" icon={HomeIcon} />
        <SidebarItem to="/client/bookings" label="Bookings" icon={ClipboardListIcon} />
        <SidebarItem to="/client/find-therapist" label="Find Therapist" icon={SearchIcon} />
        <SidebarItem to="/client/profile" label="Profile" icon={UserIcon} />
        <SidebarItem to="/client/resources" label="Resources" icon={BookOpenIcon} />
        <SidebarItem to="/client/whats-new" label="What's New" icon={SparklesIcon} />
        <SidebarItem to="/client/messages" label="Messages" icon={MessageSquareIcon} />

        {/* Logout */}
        <div className="pt-4 mt-4 border-t">
          <Button
            className="w-full bg-red-600 hover:bg-red-700 text-white text-sm py-2"
            onClick={logout}
          >
            🚪 Logout
          </Button>
        </div>
      </aside>

      {/* Subpage Content */}
      <main className="flex-1 p-6 space-y-6">
        <Outlet />
      </main>
    </div>
  );
};

export default ClientDashboard;
